import { render, staticRenderFns } from "./CostingInput.vue?vue&type=template&id=5b742b04&"
import script from "./CostingInput.vue?vue&type=script&lang=js&"
export * from "./CostingInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports